import { useApi } from '@/composables/api.ts'
import type { BoxEntry } from '@deepcloud/api-deep-box'

export const useDeepBoxDeepBoxesBoxesFavoritesStore = defineStore(
  'deepBoxDeepBoxesBoxesFavoritesStore',
  () => {
    const { deepBoxAPI } = useApi()

    const favorites = ref<BoxEntry[]>([])
    const addToFavoritesPending = ref(false)
    const removeFromFavoritesPending = ref(false)

    async function addToFavorites(payload: BoxEntry) {
      addToFavoritesPending.value = true
      const res = await deepBoxAPI.value.deepBoxesFavorites.create(
        payload.deepBoxNodeId,
        payload.boxNodeId,
      )

      favorites.value.push(payload)
      addToFavoritesPending.value = false
      return res
    }

    async function removeFromFavorites(payload: BoxEntry) {
      removeFromFavoritesPending.value = true
      try {
        const res = await deepBoxAPI.value.deepBoxesFavorites.deleteById(
          payload.deepBoxNodeId,
          payload.boxNodeId,
        )

        const index = favorites.value.findIndex(
          (fav) => fav.boxNodeId === payload.boxNodeId,
        )
        if (index > -1) {
          favorites.value.splice(index, 1)
        }
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      } finally {
        removeFromFavoritesPending.value = false
      }
    }

    return {
      // state
      favorites,
      addToFavoritesPending,
      removeFromFavoritesPending,
      // actions
      addToFavorites,
      removeFromFavorites,
    }
  },
)

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useDeepBoxDeepBoxesBoxesFavoritesStore, import.meta.hot),
  )
}
